export enum SHIPMENT_TYPES {
    OPEN = 'Open',
    PROCESSING = "Processing",
    PROCEEDED_TO_SHIPPING = "Proceeded to shipping",
    CANCELLED = "Cancelled",
    SHIPPED = "Shipped",
    DELAYED = "Delayed"
}